<template>
  <div class="main-vendor">
    <div v-if="this.$i18n.locale === 'zh'" class="vender-text">
      <p ref="vender-text-one">国际一线品牌组件， 玩的飞转</p>
      <p ref="vender-text-two">太势S系列自动裁床的豪华配置，核心硬件悉数采用国际一线品牌顶级组件。</p>
    </div>

    <div v-else class="vender-text">
      <div class="hardware-text2">
        <span style="color: #4e95d9">World-Class Components,</span>
        <span style="color: #4e95d9">Unmatched Performance.</span>
        <span>PrimeForce S-Series Auto Cutter</span>
        <span>Luxury Configuration with Global Elite Components</span>
      </div>
    </div>

    <div class="vendor-card">
      <div class="vender-image">
        <img src="../../static/home/hardware.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HardwareVendor',
  mounted() {
    this.$nextTick(() => {
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.vender-text',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          once: true
        }
      })

      masterTimeline.from('.vender-text', {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: 'power2.out'
      })

      // masterTimeline.from(this.$refs['vender-text-two'], {
      //   opacity: 0,
      //   y: 100,
      //   duration: 1,
      //   ease: 'power2.out'
      // }, 0.5)
      //
      masterTimeline.from('.vendor-card', {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: 'power2.out'
      }, 1)

      // masterTimeline.to(['.main-vendor'], {
      //   opacity: 0,
      //   y: -100,
      //   duration: 1,
      //   ease: 'power2.out'
      // }, 2)
    })
  }
}
</script>
<style scoped>
.main-vendor {
  background-color: #f5f5f7;
  width: 100%;
  height: 900px;
  margin-top: 200px;
  position: relative;
  padding-top: 100px; /* 微小的内边距即可隔离 */
}

.vender-text {
  width: 80%;
  align-items: center;
  margin: 0 auto;

  p {
    text-align: left;
  }
}

.vender-text p:nth-of-type(1) {
  background: linear-gradient(45deg, #0f455e, #42abda);
  -webkit-background-clip: text; /* 兼容 Safari 浏览器 */
  background-clip: text;
  color: transparent; /* 文字颜色设为透明，显示背景渐变 */
  font-size: 3em;
}

.vendor-card {
  width: 80%;
  background-color: white;
  border-radius: 10px;
  height: 650px;
  align-items: center;
  margin: 0 auto;
}

.vender-image {
  height: 100%;
  width: 100%;
  margin-top: 20px;

  img {
    width: 100%;
    height: 100%;
  }
}

.hardware-text2 {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: var(--font-size-lg2);
}
</style>
